import React, { useEffect, useRef, useState } from "react";
import "./ITixtagline.css";

/* ============================================================
   CONTENT  (client ka content – yahin se edit karo)
   ============================================================ */
const BRAND = "iTixFiles";
const LINES = ["Less Paperwork.", "Less Repetition.", "Clearer Processes."];
const TEXT =
  "Organize documents, track applications and keep work moving in one connected digital workspace.";

/* scroll-in hook */
const useInView = (threshold = 0.25) => {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    if (!("IntersectionObserver" in window)) {
      setSeen(true);
      return undefined;
    }
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          setSeen(true);
          io.disconnect();
        }
      },
      { threshold }
    );
    io.observe(node);
    return () => io.disconnect();
  }, [threshold]);
  return [ref, seen];
};

const ITixTagline = () => {
  const [ref, seen] = useInView();
  return (
    <section ref={ref} className={`tg ${seen ? "tg--in" : ""}`} id="tagline">
      <span className="tg__orb tg__orb--a" aria-hidden="true" />
      <span className="tg__orb tg__orb--b" aria-hidden="true" />

      <div className="tg__container">
        <span className="tg__brand">
          <i aria-hidden="true" />
          {BRAND}
        </span>

        <h2 className="tg__title">
          {LINES.map((l, i) => (
            <span
              key={l}
              className={`tg__line ${i === LINES.length - 1 ? "tg__line--accent" : ""}`}
              style={{ "--i": i }}
            >
              {l}
            </span>
          ))}
        </h2>

        <span className="tg__rule" />
        <p className="tg__text">{TEXT}</p>
      </div>
    </section>
  );
};

export default ITixTagline;